import { CardsSixty, On_Stat, Section_Title, Slider_, Toggle_Stat, Partial_Loader, Red_ , Builder_, Google_Search} from 'monica-alexandria';
import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Creator_Error_Message from '../creator/Creator_Error_Message';
import Notify_Slider_Action from '../notify/Notify_Slider_Action';
import { map_messages } from '../../utils/MapMessages';
import Snippet_Toggle_Donot from '../snippets/Snippet_Donot';
import Slider_Expand from '../slider/Slider_Expand';

const AdAccountSource = styled.div``;

const AdAccountWrapper = styled.div``;

const CampaignWrapper = styled.div``;

const FacebookWrapper = styled.div``;

const InstagramWrapper = styled.div``;

const PaidWrapper = styled.div``;

export default function Fill_Section(props) { 
    console.log(props);
   
    // this state helps us what to render in the initial load, value: 'select'|'conformation'

    const initState = props.confStatus ? 'select' : 'conformation';
    const [showHelper, setShowHelper] = useState(initState);

    const { t } = useTranslation();

    const [selectedFb, setSelectedFb] = useState();
    const [selectedInsta, setSelectedInsta] = useState();

    const [loading, setLoading] = useState(true);
    const [loadingCampaigns, setLoadingCampaigns] = useState(true);
    
    const [buttonState, setButtonState] = useState((!props.confStatus ? true : false));
    const [sliderText, setSliderText] = useState();
    const [sliderTitle, setSliderTitle] = useState();
    const [buttonIcon, setButtonIcon] = useState();

    const [filteredCampaigns, setFilteredCampaigns] = useState([]);


    // for search

    const [displayedBusinesses, setDisplayedBusinesses] = useState(props.businessAccounts);
    const [displayedAdAccounts, setDisplayedAdAccounts] = useState(props.adAccounts);
    const [displayedFbPages, setDisplayedFbPages] = useState(props.facebookPages);
    const [displayedInstaPages, setDisplayedInstaPages] = useState(props.instagramPages);
    const [displayedCampaigns, setDisplayedCampaigns] = useState([]);


    const [searchResults1, setSearchResults1] = useState();
    const [searchResults2, setSearchResults2] = useState();
    const [searchResults3, setSearchResults3] = useState();
    const [searchResults4, setSearchResults4] = useState();
    const [searchResults5, setSearchResults5] = useState();


    const [doNotIntegrate, setDoNotIntegrate] = useState(false)


    useEffect(() => {
        const applySearchResults = () => {
            if (searchResults1?.input) {
                let indexToRemove = searchResults1?.data.findIndex(obj => obj.id === 0);

                // If the index is found (not -1), remove the object
                if (indexToRemove !== -1) {
                    searchResults1?.data.splice(indexToRemove, 1);
                }
                setDisplayedBusinesses(searchResults1?.data);
            }
            else setDisplayedBusinesses(props.businessAccounts);
        };

        applySearchResults();
    }, [searchResults1]);

    // NOTE: AdAccounts do not contain 'do not integrate'
    useEffect(() => {
        const applySearchResults = () => {
            if (searchResults2?.input) setDisplayedAdAccounts(searchResults2?.data);
            else setDisplayedAdAccounts(props.adAccounts);
        };

        applySearchResults();
    }, [searchResults2]);

    useEffect(() => {
        const applySearchResults = () => {
            if (searchResults5?.input) setDisplayedCampaigns(searchResults5?.data);
            else setDisplayedCampaigns(filteredCampaigns);
        };

        applySearchResults();
    }, [searchResults5]);

    useEffect(() => {
        const applySearchResults = () => {
            if (searchResults3?.input) {

                let indexToRemove = searchResults3?.data.findIndex(obj => obj.id === 0);

                // If the index is found (not -1), remove the object
                if (indexToRemove !== -1) {
                    searchResults3?.data.splice(indexToRemove, 1);
                }
                setDisplayedFbPages(searchResults3?.data);
            }
            else setDisplayedFbPages(props.facebookPages);
        };

        applySearchResults();
    }, [searchResults3]);

    useEffect(() => {
        const applySearchResults = () => {
            if (searchResults4?.input) {

                let indexToRemove = searchResults4?.data.findIndex(obj => obj.id === 0);

                // If the index is found (not -1), remove the object
                if (indexToRemove !== -1) {
                    searchResults4?.data.splice(indexToRemove, 1);
                }
                setDisplayedInstaPages(searchResults4?.data);
            }
            else setDisplayedInstaPages(props.instagramPages);
        };

        applySearchResults();
    }, [searchResults4]);
    //
    useEffect(() => {        
        setDisplayedAdAccounts(props.adAccounts);
        //need to check if the we fetched accounts for the selected business, otherwise the displayed accounts will be 0 and the user will be trapped
        const statement = props.adAccounts.some((adAccount) => adAccount?.parentBusiness?.id === props.selectedBusiness?.id);
        console.log(statement);
        if( !statement && props.selectedBusiness) setButtonState(true);
    }, [props.adAccounts])

    useEffect(() =>{
        setDisplayedBusinesses(props.businessAccounts)
    }, [props.businessAccounts]);

    useEffect(() => {
        setFilteredCampaigns(props.campaigns?.filter((camp) => camp?.account_id === props.selectedAdAccounts[0]?.account_id));
    }, [props.selectedAdAccounts]);
    // useEffect waiting to fetch ad accounts
    useEffect(() => {
        if(props.laodingAdAccounts === true)
            setLoading(false);
    }, [props.adAccounts])

    useEffect(() => {
        if(props.campaignLoader === true) {
            setLoadingCampaigns(false);
            setFilteredCampaigns(props.campaigns?.filter((camp) => camp?.account_id === props.selectedAdAccounts[0]?.account_id));
            setDisplayedCampaigns(props.campaigns?.filter((camp) => camp?.account_id === props.selectedAdAccounts[0]?.account_id));

        }
    }, [props.campaigns]);

    useEffect(() => {
        if(props.laodingAdAccounts === false) {
            setLoading(true);
        }
    }, []);

    useEffect(() => {
        if(props.campaignLoader === false) {
            setLoadingCampaigns(true);
        }
    }, [props.campaignLoader]);

    //user action to determine conformation messages
    const [status, setStatus] = useState(props.confStatus);
    const [sectionType, setSectionType] = useState(props.sectionsType);
    const [info, setInfo] = useState({
        section:'',
        title:'',
        text:'', 
        main:'',
        red: '', 
        img:''
    });

    useEffect(() => {
        setStatus(props.confStatus);
        setSectionType(props.sectionType);
        const { section, title, text, main, red, img } = map_messages(props.sectionType, status, props.dateFrom, props.dateTo, t, props.selectedBusiness?.name, props.selectedAdAccounts[0]?.name, selectedFb?.name, selectedInsta?.instagram_business_account.username, props.flow, props.currentSectionIndex);
        setInfo(prevInfo => ({
            ...prevInfo,
            section: section, 
            title: title,
            text: text,
            main: main,
            red: red,
            img: img
        }));
        setSliderTitle(section);
    }, [props, status, sectionType]);

    // to init sliderText
    useEffect(() => {
        if(!sliderText){
            setSliderText(props.confStatus ? (t('Done')): info.main);
        }
        else if(sliderText !== (t('Done'))) {
            setSliderText(info.main)
        }

    }, [info]);
    

    const fetchOrganicError = props.errors?.fetchOrganicPages?.error;
    const fetchBusinessesError = props.errors?.fetchBusinesses?.error;
    const fetchAdAccountsError = props.errors?.fetchAdAccounts?.find((ac) => ac?.extraInfo?.parentBusinessId === props.selectedBusiness?.id)?.error;

    if (fetchOrganicError && (props.sectionType === 'instagram' || props.sectionType === 'facebook')) {
        return <Creator_Error_Message error={fetchOrganicError} errorType={'fetchOrganicPages'} onClick={props.onClick} sliderTitle={t('Section Sources')} />;
    }
    
   
    // could make cases for every sectionn type here
    const onDone = () => {
        if(sliderText === (t('Done'))) {
            setShowHelper('conformation');
            setSliderText(info.main);
            setSliderTitle(info.section);
            setButtonIcon('Next');
            setDoNotIntegrate(false);

        }
        else {
            props.onInitial(); 
            setShowHelper('select'); 
            props.changeConformationStatus(false);
            setSliderText((t("Done")));
            setButtonIcon('Check')
            setSliderTitle(info.section);
            setButtonState(false);
            props.resetMetaHelperFields();
            }
        }
    

    const onSkip = () => {
        props.skipSection();
        props.changeConformationStatus(false);
    }

    return (
        <Slider_ onClick={() => onDone()} text={sliderText} title={sliderTitle} disabled={!buttonState} icon={buttonIcon}> 
            {props.sectionType === 'paid' ? (
            <>
 
                {showHelper === 'select' ?
                
                    (
                    <PaidWrapper>
                        
                        {props.businessAccounts?.length > 15 ?
                        <>
                            {props?.businessCursor !== false ?
                                    <Partial_Loader/> :
                            <Builder_ title={t('Search for Business Manager Account')}>
                                <Google_Search file={props.businessAccounts} fileKeys={['name']} defaultValue={''} sanitize={true}      placeholder={t('Search Business Manager')} setResults={(data) => setSearchResults1(data)} debounceTime={750} minMatchCharacters={3} maxMatchCharacters={50} disabled={false} isCaseSensitive={false} maxAcceptedScore={0.8} />
                            </Builder_> 
                            }
                        </>
                        :
                        null
                        }
                        <AdAccountSource>
                            <Section_Title text={t('Select Facebook Business Manager')} />
                            {fetchBusinessesError ? (
                                <Creator_Error_Message error={fetchBusinessesError} errorType={'fetchBusinesses'} onClick={props.onClick} noSlider={true} />
                            ) : (
                                
                                <CardsSixty>
                                    {!props.selectedBusiness ?
                                    <>
                                    {displayedBusinesses?.map((item, i) => {
                                        const isAdded = item.id === props.selectedBusiness?.id;
                                        if(item.id === 0) {
                                            return (
                                                <Snippet_Toggle_Donot 
                                                    text={item.name}
                                                    onClick={()=> {  
                                                        const newValue = !doNotIntegrate;
                                                        setDoNotIntegrate(newValue);
                                                        setButtonState(newValue ? true : false);
                                                        if(props.selectedBusiness)
                                                            props.removeSource(props.selectedBusiness, 'business')
                                                        if(doNotIntegrate === false)
                                                            props.changeConformationStatus(false); 
                                                    }} 
                                                    key={i}
                                                    id={i}
                                                    active={doNotIntegrate}
                                                />
                                            )
                                        }
                                        else {

                                            return (
                                                <Toggle_Stat key={i} id={i} text={item.name} 
                                                onClick={() => !isAdded ? (props.addSource(item, 'business'), setDoNotIntegrate(false)) : (props.removeSource(item, 'business'), setButtonState(false))} 
                                                active={isAdded} />
                                            )
                                        }
                                    })}
                                    </>
                                    :
                                    <>
                                    <Toggle_Stat
                                        key={props.selectedBusiness?.id}
                                        id={0}
                                        text={props.selectedBusiness?.name}
                                        onClick={() => {
                                            props.removeSource(props.selectedBusiness, 'business'); 
                                            if(props.selectedAdAccounts) {
                                                props.removeSection(props.selectedAdAccounts[0], 'adAccount');
                                            } 
                                            setButtonState(false);}}
                                        active={true}
                                    />
                                    </>
                                    }
                                </CardsSixty>
                                
                                
                            )}
                        </AdAccountSource>

                        {props.selectedBusiness && (
                            <AdAccountWrapper>
                                {props.adAccounts.length > 15 ?
                                <Builder_ title={t('Search for Ad Accounts')}>
                                    <Google_Search file={props.adAccounts} fileKeys={['name']} defaultValue={''} sanitize={true}      placeholder={t('Search Ad Account')} setResults={(data) => setSearchResults2(data)} debounceTime={750} minMatchCharacters={1} maxMatchCharacters={50} disabled={false} isCaseSensitive={false} maxAcceptedScore={0.6} />
                                </Builder_> 
                                : null }

                                <Section_Title text={t('Select Facebook Ad Accounts')} />
                                {fetchAdAccountsError ? (
                                    <Creator_Error_Message error={fetchAdAccountsError} errorType={'fetchAdAccounts'} onClick={props.onClick} noSlider={true} />
                                ) : <>
                                    {loading ?<Partial_Loader/> :
                                    <CardsSixty>
                                        {!props.selectedAdAccounts?.length > 0 ?
                                        <>
                                        {displayedAdAccounts
                                            ?.filter((adAccount) => adAccount?.parentBusiness?.id === props.selectedBusiness?.id)
                                            ?.map((item, i) => {
                                                const isAdded = props.selectedSections.some((obj) => obj.type === 'paid' && obj.sectionData?.find((sd) => sd.type === 'adAccount').id === item.id);
                                                
                                                return <Toggle_Stat key={i} id={i} text={item.name} 
                                                                    onClick={() => !isAdded ? (props.addSection(item, 'adAccount'), props.changeConformationStatus(true), setButtonState(true)) : (props.removeSection(item, 'adAccount'), props.changeConformationStatus(false), setButtonState(false))} 
                                                                    active={isAdded} />
                                                                    
                                                                })}
                                        </>
                                        : 
                                        <Toggle_Stat
                                            key={props.selectedAdAccounts[0]?.id}
                                            id={0}
                                            text={props.selectedAdAccounts[0]?.name}
                                            onClick={() => {props.removeSection(props.selectedAdAccounts[0], 'adAccount'); props.changeConformationStatus(false); setButtonState(false);}}
                                            active={true}
                                        />
                                        }
                                    </CardsSixty>
                                    }
                                    </>
                                }
                                
                            </AdAccountWrapper>
                        )}
                    {props.selectedAdAccounts.length > 0 && filteredCampaigns?.length >= 0 ?
                        <Slider_Expand
                            filteredCampaigns={filteredCampaigns}
                            setSearchResults={setSearchResults5}
                            loadingCampaigns={loadingCampaigns}
                            displayedCampaigns={displayedCampaigns}
                            selectedCampaigns={props.selectedCampaigns}
                            selectedAdAccounts={props.selectedAdAccounts}
                            selectedSections={props.selectedSections}
                            addCampaign={props.addCampaign}
                            removeCampaign={props.removeCampaign}
                            title={t('Specific Campaign (Optional)')}
                            position={props.currentSectionIndex}
                        />
                        : null}
                    </PaidWrapper>
                    )
                    :null}
                    { showHelper === 'conformation' ?
                    (<Notify_Slider_Action 
                        title={info.title}
                        text={info.text} 
                        textRed={info.red}
                        img={info.img}
                        // onClickMain={() => {props.onInitial(); setShowHelper('select'); props.changeConformationStatus(true);}} 
                        onClickGrey={()=> {setShowHelper('select'); setSliderText((t('Done')))}}
                        onRed={() => {onSkip(); setButtonState(true);}}

                    />)
                    :null}
                
            </>
            ) : null}

            {props.sectionType === 'facebook'  && (
                <>
                    {props.facebookPages.length > 0 && props.facebookPages ? (
                        <>
                            {showHelper === 'select' ? (
                                <FacebookWrapper>
                                    {props.facebookPages.length > 15 ?
                                    <Builder_ title={t('Search for Facebook Page')}>
                                        <Google_Search file={props.facebookPages} fileKeys={['name']} defaultValue={''} sanitize={true}      placeholder={t('Search Facebook Page')} setResults={(data) => setSearchResults3(data)} debounceTime={750} minMatchCharacters={1} maxMatchCharacters={50} disabled={false} isCaseSensitive={false} maxAcceptedScore={0.6} />
                                    </Builder_> 
                                    : null }
                                    <Section_Title text={t('Facebook Organic')} />
                                    <CardsSixty>
                                        {displayedFbPages.map((item, i) => {
                                            let isAdded = props.selectedSections.some((obj) => obj.type === 'facebook' && obj.sectionData?.find((sd) => sd.type === 'facebookPage').id === item.id);
                                            if(item.id === 0) {
                                                return (
                                                    <Snippet_Toggle_Donot 
                                                        text={item.name}
                                                        onClick={() => {
                                                            const newValue = !doNotIntegrate;
                                                            setDoNotIntegrate(newValue);
                                                            setButtonState(newValue ? true : false);
                                                            if(selectedFb)
                                                                props.removeSection(selectedFb, 'adAccount');

                                                            if(doNotIntegrate === false)
                                                                props.changeConformationStatus(false); 
                                                          }}
                                                        key={i}
                                                        id={i}
                                                        active={doNotIntegrate}
                                                />
                                                )
                                            }
                                            else {  
                                                return (
                                                    <Toggle_Stat
                                                        key={i}
                                                        id={i}
                                                        text={item.name}
                                                        onClick={() =>
                                                            !isAdded
                                                                ? (props.addSection(item, 'adAccount'), props.changeConformationStatus(true), setSelectedFb(item), setButtonState(true), setDoNotIntegrate(false))
                                                                : (props.removeSection(item, 'adAccount'), props.changeConformationStatus(false), setButtonState(false))
                                                        }
                                                        active={isAdded}
                                                    />
                                                );
                                                }
                                        })}
                                        
                                    </CardsSixty>
                                </FacebookWrapper>
                            ) : null}
                            {showHelper === 'conformation' ? (
                                <Notify_Slider_Action  
                                    status={props.confStatus}
                                    title={info.title}
                                    text={info.text} 
                                    textRed={info.red}
                                    img={info.img}
                                    onClickGrey={()=> {setShowHelper('select'); setSliderText((t('Done')))}}
                                    onRed={() => {onSkip(); setButtonState(true);}} 
                                />
                            ) : null}
                        </>
                    ) : (
                        // Handle case when facebookPages is empty
                        // You can render a message or another component here
                        <Red_ text="Do not integrade with Facebook Page" 
                            onClick={()=> {  
                                if(selectedFb)
                                    props.removeSection(selectedFb, 'adAccount');
                                setShowHelper('conformation'); 
                                props.changeConformationStatus(false); 
                                setButtonState(true);
                                setSliderText(info.main);
                                setSliderTitle(info.section);
                            }}   
                        />
                    )}
                </>
            )}


            {props.sectionType === 'instagram' && props.instagramPages && (
                <>
                    {props.instagramPages.length > 0 && props.instagramPages? (
                        <>
                            {showHelper === 'select' ? (
                                <InstagramWrapper>
                                    {props.instagramPages.length > 15 ?
                                    <Builder_ title={t('Search for Instagram Page')}>
                                        <Google_Search file={props.instagramPages} fileKeys={['name']} defaultValue={''} sanitize={true}      placeholder={t('Search Instagram Page')} setResults={(data) => setSearchResults4(data)} debounceTime={750} minMatchCharacters={1} maxMatchCharacters={50} disabled={false} isCaseSensitive={false} maxAcceptedScore={0.6} />
                                    </Builder_> 
                                    : null }
                                    <Section_Title text={t('Instagram Organic')} />
                                    <CardsSixty>
                                        {displayedInstaPages.map((item, i) => {
                                            const isAdded = props.selectedSections.some((obj) => obj.type === 'instagram' && obj.sectionData?.find((sd) => sd.type === 'instagramPage')?.id === item.instagram_business_account?.id);
                                            if(item.instagram_business_account?.id === 0) {
                                                return(
                                                    <Snippet_Toggle_Donot 
                                                        text={item.name}
                                                        onClick={()=> {  
                                                            const newValue = !doNotIntegrate;
                                                            setDoNotIntegrate(newValue);
                                                            setButtonState(newValue ? true : false);
                                                            if(selectedInsta)
                                                                props.removeSection(selectedInsta, 'adAccount');

                                                            if(doNotIntegrate === false)
                                                                props.changeConformationStatus(false); 
                                                        }} 
                                                        key={i}
                                                        id={i}
                                                        active={doNotIntegrate}
                                                    />
                                                )
                                            }
                                            else {
                                                return (
                                                    <Toggle_Stat
                                                        key={i}
                                                        id={i}
                                                        text={item.instagram_business_account?.username}
                                                        onClick={() =>
                                                            !isAdded
                                                                ? (props.addSection(item, 'adAccount'), props.changeConformationStatus(true), setSelectedInsta(item), setButtonState(true), setDoNotIntegrate(false))
                                                                : (props.removeSection(item, 'adAccount'), props.changeConformationStatus(false), setButtonState(false))
                                                        }
                                                        active={isAdded}
                                                    />
                                                );
                                            }
                                        })}
                                        {/* <Red_ text="Do not integrate with Instagram Page" 
                                            onClick={()=> {  
                                                if(selectedInsta)
                                                    props.removeSection(selectedInsta, 'adAccount');
                                                setShowHelper('conformation'); 
                                                props.changeConformationStatus(false); 
                                                setButtonState(true);
                                                setSliderText(info.main);
                                                setSliderTitle(info.section);
                                            }}   
                                        /> */}
                                    </CardsSixty>
                                </InstagramWrapper>
                            ) : null}
                            {showHelper === 'conformation' ? (
                                <Notify_Slider_Action 
                                    title={info.title}
                                    text={info.text} 
                                    textRed={info.red}
                                    img={info.img}
                                    status={props.confStatus}
                                    onClickGrey={()=> {setShowHelper('select'); setSliderText((t('Done')))}}
                                    onRed={() => {onSkip(); setButtonState(true);}}
                                />
                            ) : null}
                        </>
                    ) : (
                        // Handle case when instagramPages is empty
                        // You can render a message or another component here
                        <Red_ text="Do not integrate with Instagram Page" 
                            onClick={()=> {  
                                if(selectedInsta)
                                    props.removeSection(selectedInsta, 'adAccount');
                                setShowHelper('conformation'); 
                                props.changeConformationStatus(false); 
                                setButtonState(true);
                                setSliderText(info.main);
                                setSliderTitle(info.section);
                            }}   
                        />
                    )}
                </>
)}

        </Slider_>
    );
}
